import React from "react";
import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import "./termsAndConditions.css";
import ProgressBarLoader from "../../components/ProgressBarLoader/ProgressBarLoader";

const TermsAndConditions = () => {
  return (
    <div>
      <ProgressBarLoader />
      <Breadcrumbs  title="Términos y Condiciones" pagename="Términos y Condiciones" />
      <div className="container py-5">
        <h1 className="text-center mb-5 page-title">Términos y Condiciones</h1>
        <div className="terms-content">
        Generales, descuentos y canales de venta
GENERALES
Su boleto es su seguro de viajero consérvelo. Válido para el Origen, Destino, fecha y
hora indicada.
IDENTIFICACIÓN
En todos los casos de descuentos presentar una identificación oficial, original y
vigente que acrediten la identidad de la persona que viaja al momento de la compra
y/o asegurar que el pasajero sea mayor de edad.
ABORDAJE
1. Los boletos electrónicos se pueden presentar en dispositivos móviles o
impreso si el pasajero lo imprime exclusivamente para abordar y documentar
su equipaje.
2. El boleto de taquilla se debe presentar en físico para abordar y documentar
su equipaje.
TU VIAJE ADO Y SEGUIR MI VIAJE (APP)
1. Esta aplicación es para su uso de los pasajeros de las marcas ADO GL, ADO
Platino y Diamante.
2. Es un servicio de cortesía, no implica un costo adicional para los usuarios, por
lo que TRANSPORTES SALINACRUCENSES SC DE RL en lo sucesivo “La
empresa” no se responsabiliza por daños o perjuicios derivados del acceso,
uso o mala utilización de los contenidos de esta aplicación.
3. Esta aplicación tiene como propósito brindar una referencia de tiempos de
traslado, así como trayectos de los autobuses de las marcas mencionadas
anteriormente, de origen a destino, sin que implique compromiso u obligación
de tiempos de llegada de los vehículos. “La empresa”, no ofrece garantía
explícita o implícita y se reserva el derecho de modificar la información aquí
contenida, cuando lo estime conveniente y sin previo aviso, pudiendo incluso
limitar o no permitir el acceso a dicha información.
4. “La empresa” no asume compromiso, ni obligación sobre tiempos de llegada
de los autobuses, por lo que cualquier reclamación en relación al tiempo que
refiera la aplicación no genera obligación de compensación en ningún sentido
al pasajero.
5. “La empresa” no asume responsabilidad por fallas en la comunicación de
internet, ya sea de la propia empresa, o del usuario que esté consultando sus
tiempos de trayecto.
6. Para el uso de esta herramienta de cortesía no se solicitará al pasajero dato
personal alguno por lo que el aviso de privacidad correspondiente, por parte
de “La empresa”, publicado en www.salinacrucenses.com.mx se altera de
forma alguna.
7. El contenido de esta aplicación así como sus actualizaciones, son propiedad
de “La empresa”. Los textos, nombres, imágenes, videos, publicidad y
herramientas tecnológicas que componen esta aplicación son de uso
exclusivo para fines comerciales de la misma y se encuentran protegidos por
las leyes de los Estados Unidos Mexicanos. Cualquier otro uso, incluyendo
reproducción, modificación, distribución, transmisión, exhibición, ejecución o
comercialización del contenido de este sitio se encuentra estrictamente
prohibido.
8. “La empresa” no asume responsabilidad alguna que derive del intercambio de
información electrónica entre usuarios de Internet y no adquiere ninguna
responsabilidad por causa de problemas técnicos que se pudieran producir en
equipos informáticos que se utilicen durante la conexión a la red de Internet,
ya sea a través de esta aplicación o de otras.
9. Al acceder a esta aplicación usted reconoce haber leído y entendido sus
contenidos y manifiesta estar de acuerdo con los mismos.
10. Las marcas de los servicios de transporte utilizados por esta aplicación, así
como sus diferentes diseños se encuentran debidamente registrados, por lo
que su uso total o parcial está estrictamente prohibido.
11. Todo el diseño de esta aplicación incluyendo todos sus contenidos como
gráficos, fotografías, textos, información, etc. son derechos reservados
de TRANSPORTES SALINACRUCENSES S.C DE R.L., con domicilio en Antonio
Caso 107, Esquina Periferico, Col. Jose Vasconcelos, Oaxaca de Juarez,
Oaxaca.
12. Para atender dudas, sugerencias o reclamaciones ponemos a su disposición
el teléfono (HOLA) (951) 569 5305 Interior de la república, WhatsApp para
enviar mensaje (951) 569 5305 , así como correo electrónico
soluciones@salinacrucenses.com
DESCUENTOS
1. En todos los casos de descuentos, estos aplican sobre el precio regular
(entero) disponible y vigente al momento de la compra (sin promociones, ni
Compra con Tiempo, ni Compra Anticipada).
2. Debe presentar credencial oficial, original y vigente, que acredite el derecho al
descuento al comprar su boleto (estudiantes, maestros, INAPAM, CONADIS),
al abordar el autobús y en cualquier momento que se le solicite, de no hacerlo
se le cobrará la diferencia restante del precio regular (entero) del boleto.
3. No se aceptan copias simples de las credenciales, ni de tiras de materias.
4. Todas las credenciales falsas detectadas se retienen y se avisa a las
autoridades.
5. No son acumulables con otros descuentos y/o promociones.
6. En caso de transferencia, los boletos con descuento quedan sujetos a
disponibilidad en el nuevo viaje.
NIÑOS
1. El descuento se aplica a niños de 0 y hasta 2 años cumplidos.
2. A partir de los 3 años, se tendrá que pagar boleto de adulto (entero).
3. Si el niño está en el límite de edad, se deberá presentar un documento oficial
que lo acredite (acta de nacimiento, credencial escolar, CURP o pasaporte).
4. En cualquier caso, los menores de 18 años deben viajar en compañía de un
adulto.
INAPAM – INSEN 10%
1. Es necesario presentar la credencial original y vigente de INAPAM (antes
INSEN) para obtener su descuento (no se aceptan copias).
2. Limitado a 2 descuentos por corrida en corridas normales en todas nuestras
marcas y clases de servicio conforme al DOF de 07/01/1982.
Los pagos serán procesados mediante Openpay.
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
